"use client";

import Image from "next/image";

interface HeroSectionProps {
  tenant: {
    name: string;
    logoUrl?: string;
    primaryColor: string;
  };
  title?: string | null;
  description?: string | null;
  whitelabel?: boolean;
}

export function HeroSection({ tenant, title, description, whitelabel }: HeroSectionProps) {
  const displayTitle = title || tenant.name;
  const displayDescription = description || "Discover our interactive scavenger hunts and earn digital rewards";

  return (
    <div className="text-center mb-12">
      {tenant.logoUrl && (
        <div className="relative h-16 w-48 mx-auto mb-6">
          <Image
            src={tenant.logoUrl}
            alt={tenant.name}
            fill
            className="object-contain"
            unoptimized
          />
        </div>
      )}
      <h1
        className="text-4xl font-bold text-gray-900 mb-6"
        style={whitelabel ? { color: 'var(--theme-text, #111827)' } : undefined}
      >
        {displayTitle}
      </h1>
      <p
        className="text-xl text-gray-500 mb-8"
        style={whitelabel ? { color: 'var(--theme-text, #6B7280)', opacity: 0.8 } : undefined}
      >
        {displayDescription}
      </p>
    </div>
  );
}
